module.exports = __webpack_public_path__ + "web/img/type-6.be9376fc.png";